import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, message, Button } from "antd";
import { Table } from "./../../../components/table";
import { generateTableColumns } from "./config";
import { SettingsServer } from "./../../../server";
import { Operation } from "./operation";
import { langCommon } from "../../../locales";

const server = SettingsServer.Email

export const Email = () => {
    const operationRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData([res]);
        }
    });

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ operationRef, loading, setLoading, refresh });
    }, [operationRef, loading, setLoading, refresh]);

    return (
        <div>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}